import {useEffect} from 'react';
import {useQuery} from 'react-query';
import {getForms, getReports} from './services/service';
import {IReport} from './types';
import {getFormatedDate} from './componenets/ReportList/utils';
import {priority} from '@priority-software/priority-proto-api/lib';

export const useReportQuery = reportsScreenStore => {
    const {isLoading: isLoadingForms, data: forms} = useQuery(
        ['forms', reportsScreenStore?.session],
        getForms,
        {
            enabled: !!reportsScreenStore?.isOpen && reportsScreenStore?.forms?.size === 0
        }
    );

    const {isLoading: isLoadingReports, data: reports} = useQuery(
        ['reports', reportsScreenStore?.session],
        getReports,
        {
            enabled: !!reportsScreenStore?.isOpen,
            select: data => {
                if (window.location.search.includes('_noreports=1')) {
                    return [];
                } else {
                    return data;
                }
            }
        }
    );

    useEffect(() => {
        if (forms && reports) {
            const formsMap = new Map(forms.map(form => [form.NodeId, form]));
            const serialzeReports: IReport[] = reports.map(report => ({
                title: report.Title,
                id: report.ReportId,
                createdDate: getFormatedDate(report.CreatedDate),
                updateTime: getFormatedDate(report.UpdateTime, true),
                isGeneral: report.General,
                baseForm: formsMap.get(report.RootNodeId)?.Title,
                userName: report.Username,
                nodeId: report.RootNodeId,
                isOldReport:
                    report.ReportType === priority.netitems.nrest.RepType.RepType_OldReport,
                isActive: report.InUse,
                reportType: report.ReportType
            }));
            reportsScreenStore?.setReports(serialzeReports);
            reportsScreenStore?.setForms(formsMap);
        }
    }, [forms, reports]);

    return {isLoading: isLoadingForms || isLoadingReports || !reportsScreenStore?.reports};
};
